/*
 * File: /src/services/groupServices.js
 * Created Date: Friday June 14th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 14th June 2019 9:55:39 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import { AD_BASE_FOLDERS_PATH } from '../constants';
import { authedAxios } from '../shared/axiosWrapper';

export default {
  /**
   * Fetch all Folders
   *
   * @returns
   */
  fetchFolders(type, parentId) {
    let queryParams = {}
    if (type) {
      queryParams['type'] = type;
    }
    if (parentId) {
      queryParams['parentId'] = parentId;
    }
    return authedAxios.get(AD_BASE_FOLDERS_PATH, {params: queryParams});
  },

  /**
   * Save New Folder
   *
   * @param {*} folderData
   * @returns
   */
  newFolder(folderData) {
    return authedAxios.post(AD_BASE_FOLDERS_PATH, folderData);
  },

  /**
   * Delete Group
   *
   * @param {*} folderId
   * @returns
   */
  deleteFolderById(folderId) {
    return authedAxios.delete(AD_BASE_FOLDERS_PATH + folderId);
  },

  /**
   * Update Folder Name by ID
   * @param {number} folderId
   * @param {string} name
   */
  updateFolderNameById(folderId, name) {
    return authedAxios.put(AD_BASE_FOLDERS_PATH + folderId, { folder_name: name });
  }
};
